import { IEnvironment, PROD_API, SENTRY_DSN } from './environment.interface';

export const environment: IEnvironment = {
  name: 'production-test',
  production: true,
  services: {
    api: PROD_API,
  },
  sentryDsn: SENTRY_DSN,
  frontappChatId: '650412e8d35353baa3ad91db97bbe95f',
  cookieHub: 'ec26117f',
};
